// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__1YIbX","title":"ClientReferral_title__1JOmE","itemText":"ClientReferral_itemText__3ZJ3k"};